import { lazy } from 'react';

const LazyMainDashboard = lazy(() => import('./main-dashboard'));

export default LazyMainDashboard;
